import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

// CREATE ACTION
export const qrTypeCreate = createAsyncThunk("qrTypeCreate", async ({ data }, { rejectWithValue }) => {
    try {
      const response = await axiosHttp.post("lcqr/createtype", data);
      return response.data;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

const qrTypeCreateSlice = createSlice({
  name: "qrTypeCreateSlice",
  initialState: {
    isLoading: false,
    isError: false,
    error: null,
    data: null,
  },
  reducers: {
    resetCreateState: (state) => {
      state.isLoading = false;
      state.isError = false;
      state.error = null;
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(qrTypeCreate.pending, (state) => {
      state.isLoading = true;
      state.isError = false;
    });
    builder.addCase(qrTypeCreate.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.data = action.payload;
    });
    builder.addCase(qrTypeCreate.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.error = action.payload;
    });
  },
});

export const { resetCreateState } = qrTypeCreateSlice.actions;
export default qrTypeCreateSlice.reducer;
